/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <!-- <img class="logoimg" src="../assets/img/icons.jpg" alt=""> -->
      <div>驾考后台管理</div>
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i  :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
        <el-menu-item-group >
          <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
            <i  :class="chmenu.icon"></i>
            <span>{{chmenu.menuname}}</span>
          </el-menu-item>
        </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: 'leftnav',
  data() {
    return {
      type:false,
      collapsed: false,
      allmenu: [],
      user:{}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    console.log( this.user );
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 11,
          icon: 'el-icon-s-home',
          menuname: '基础管理',
          hasThird: false,
          url: null,
          menus: [
            {
              menuid: 12,
              icon: 'el-icon-s-cooperation',
              menuname: '商品管理',
              hasThird: 'N',
              url: 'goods/Goods',
              menus: null
            },
            {
              menuid: 13,
              icon: 'el-icon-s-custom',
              menuname: '用户管理',
              hasThird: 'N',
              url: 'index/index',
              menus: null
            },
            {
              menuid: 14,
              icon: 'el-icon-s-custom',
              menuname: '教练管理',
              hasThird: 'N',
              url: 'coach/Coach',
              menus: null
            },
            {
              menuid: 15,
              icon: 'el-icon-s-goods',
              menuname: '产品管理',
              hasThird: 'N',
              url: 'product/index',
              menus: null
            }
          ]
        },
        {
          menuid: 21,
          icon: 'el-icon-s-order',
          menuname: '订单管理',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 22,
              icon: 'el-icon-s-order',
              menuname: '订单',
              hasThird: 'N',
              url: 'pay/Order',
              menus: null
            }
          ]
        },
        {
          menuid: 31,
          icon: 'el-icon-s-promotion',
          menuname: '习题管理',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 32,
              icon: 'el-icon-s-order',
              menuname: '习题列表',
              hasThird: 'N',
              url: 'topic/index',
              menus: null
            },
            {
              menuid: 33,
              icon: 'el-icon-s-order',
              menuname: '习题分类',
              hasThird: 'N',
              url: 'group/index',
              menus: null
            }
          ]
        },
        {
          menuid: 41,
          icon: 'el-icon-video-camera-solid',
          menuname: '视频管理',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 42,
              icon: 'el-icon-video-camera-solid',
              menuname: '视频列表',
              hasThird: 'N',
              url: 'video/index',
              menus: null
            },
            {
              menuid: 43,
              icon: 'el-icon-s-claim',
              menuname: '考试秘籍',
              hasThird: 'N',
              url: 'secret/index',
              menus: null
            },
            {
              menuid: 44,
              icon: 'el-icon-s-custom',
              menuname: '帮助中心',
              hasThird: 'N',
              url: 'Helps/index',
              menus: null
            }
          ]
        },
        {
          menuid: 51,
          icon: 'el-icon-s-custom',
          menuname: '讲师管理',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 52,
              icon: 'el-icon-s-custom',
              menuname: '讲师列表',
              hasThird: 'N',
              url: 'lecturer/index',
              menus: null
            },
            {
              menuid: 53,
              icon: 'el-icon-s-order',
              menuname: '课程列表',
              hasThird: 'N',
              url: 'course/index',
              menus: null
            }
          ]
        },
        {
          menuid: 61,
          icon: 'el-icon-s-tools',
          menuname: '图表',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 62,
              icon: 'icon-provider-manage',
              menuname: '数据可视化',
              hasThird: 'N',
              url: 'charts/statistics',
              menus: null
            }
          ]
        }
      ],
      msg: 'success'
    }
    let res1 = {
      success: true,
      data: [
      {
          menuid: 21,
          icon: 'el-icon-s-order',
          menuname: '订单管理',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 22,
              icon: 'el-icon-s-order',
              menuname: '订单',
              hasThird: 'N',
              url: 'pay/Order',
              menus: null
            }
          ]
        },
      {
          menuid: 150,
          icon: 'el-icon-s-custom',
          menuname: '讲师管理',
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 159,
              icon: 'el-icon-s-custom',
              menuname: '讲师列表',
              hasThird: 'N',
              url: 'lecturer/index',
              menus: null
            }
          ]
        }
      ],
      msg: 'success'
    }
    if(this.user.Permissions_type == 1){
      this.allmenu = res.data
    }else if(this.user.Permissions_type == 2){
      this.allmenu = res1.data
    }else{
      this.allmenu = res1.data
    }
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  display: flex;
  justify-content: center;
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 20px;
  color: #ffffff;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue